class ExcelConverterService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/excelConverters';
  }

  async upload({ formData }) {
    const { data, headers } = await this.axios.put(`${this.url}/convert`, formData,
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });
    return { data, filename: headers['x-suggested-filename'] };
  }
}

export default ExcelConverterService;
